<div class="cl-device-select-input cl-device-input" fxFlex *ngIf="deviceInput.isVisible">
    <mat-label *ngIf="!hideTitle" class="text-contrast">{{ deviceInput.displayText }}</mat-label>
    <div *ngIf="hasManyItems()">
        <mat-form-field *ngIf="formControl">
            <mat-select
                [formControl]="formControl"
                (selectionChange)="invokeCommand($event)"
                [disableControl]="!deviceInput.isEnabled"
            >
                <mat-option *ngFor="let item of deviceInput.$valueList; trackBy: trackByValue" [value]="item.value">
                    {{ item.displayText }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div *ngIf="!hasManyItems()">
        <mat-button-toggle-group
            *ngIf="formControl"
            [formControl]="formControl"
            (change)="invokeCommand($event)"
            [disableControl]="!deviceInput.isEnabled"
        >
            <mat-button-toggle *ngFor="let item of deviceInput.$valueList; trackBy: trackByValue" [value]="item.value"
                               ngDefaultControl>
                {{ item.displayText }}
            </mat-button-toggle>
            <br>
        </mat-button-toggle-group>
    </div>
</div>

